const PROMOTION_GOODS_CACHE_KEY = "promotion_goods_cache";
const DEFAULT_CACHE_MAX_AGE = 5 * 60 * 1000;

function getSessionStorage() {
  if (typeof window === "undefined" || !window.sessionStorage) {
    return null;
  }

  return window.sessionStorage;
}

function normalizeCacheValue(value) {
  return value ? String(value).trim() : "";
}

function buildCacheId({ pCode, templateWebUrl }) {
  const normalizedPCode = normalizeCacheValue(pCode);
  const normalizedTemplateWebUrl = normalizeCacheValue(templateWebUrl);

  if (!normalizedPCode || !normalizedTemplateWebUrl) {
    return "";
  }

  return `${normalizedPCode}::${normalizedTemplateWebUrl}`;
}

function clearPromotionGoodsCache() {
  const storage = getSessionStorage();

  if (!storage) {
    return;
  }

  storage.removeItem(PROMOTION_GOODS_CACHE_KEY);
}

function setPromotionGoodsCache({ pCode, templateWebUrl, responseData }) {
  const storage = getSessionStorage();
  const cacheId = buildCacheId({ pCode, templateWebUrl });

  if (!storage || !cacheId || !responseData) {
    return;
  }

  storage.setItem(
    PROMOTION_GOODS_CACHE_KEY,
    JSON.stringify({
      cacheId,
      createdAt: Date.now(),
      responseData,
    })
  );
}

function takePromotionGoodsCache({
  pCode,
  templateWebUrl,
  maxAgeMs = DEFAULT_CACHE_MAX_AGE,
}) {
  const storage = getSessionStorage();

  if (!storage) {
    return null;
  }

  const rawCache = storage.getItem(PROMOTION_GOODS_CACHE_KEY);

  if (!rawCache) {
    return null;
  }

  try {
    const parsedCache = JSON.parse(rawCache);
    const expectedCacheId = buildCacheId({ pCode, templateWebUrl });
    const createdAt = Number(parsedCache.createdAt) || 0;

    if (!parsedCache.cacheId || !parsedCache.responseData || !expectedCacheId) {
      clearPromotionGoodsCache();
      return null;
    }

    if (Date.now() - createdAt > maxAgeMs) {
      clearPromotionGoodsCache();
      return null;
    }

    if (parsedCache.cacheId !== expectedCacheId) {
      return null;
    }

    clearPromotionGoodsCache();
    return parsedCache.responseData;
  } catch (error) {
    clearPromotionGoodsCache();
    return null;
  }
}

module.exports = {
  PROMOTION_GOODS_CACHE_KEY,
  setPromotionGoodsCache,
  takePromotionGoodsCache,
  clearPromotionGoodsCache,
};
